import { Select, Form } from 'antd';
import styled from 'styled-components';

import Image from 'global/Image';
import If from 'global/Common/If';

interface PortfolioOption {
  value: string;
  label: string;
  isMain: boolean;
}

interface PortfolioSelectProps {
  id: string;
  label: string;
  name: string;
  value: string;
  options: PortfolioOption[];
  onChange: (value: string) => void;
  disabled?: boolean;
}

export const CustomOption = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  border-bottom: 1px solid red;

  &:last-child {
    border-bottom: none;
  }

  .option-text {
    display: flex;
  }

  .option-text .main-porto {
    display: none;
    margin-left: 4px;
    color: #858585;
    font-weight: 400;
    font-family: ProximaNovaRg;
  }

  .sub-text {
    color: gray;
    font-size: 12px;
  }

  img {
    display: none;
  }
`;

const PortfolioSelect: React.FC<PortfolioSelectProps> = ({
  id,
  label,
  name,
  value,
  options,
  onChange,
  disabled = false,
}) => (
  <Form.Item name={name} label={label}>
    <div id={`${id}-select-${name}`}>
      <Select
        placeholder="Select Portfolio"
        value={value}
        onChange={onChange}
        suffixIcon={<Image src="/icon/chevron-down.svg" alt="" />}
        style={{ width: '100%' }}
        transitionName=""
        disabled={disabled}
        getPopupContainer={() =>
          document.getElementById(`${id}-select-${name}`)
        }
      >
        {options.map((subAccount) => (
          <Select.Option key={subAccount.value} value={subAccount.value}>
            <CustomOption className="transfer-custom-select">
              <div className="option-text">
                <span className="main-text">{subAccount.label}</span>
                <If condition={subAccount.isMain}>
                  <span className="main-porto"> • Main</span>
                </If>
              </div>
              <Image
                src="/icon/check/filled.svg"
                alt="check-icon"
                width={18}
                height={18}
                className="transfer-check-icon"
              />
            </CustomOption>
          </Select.Option>
        ))}
      </Select>
    </div>
  </Form.Item>
);

export default PortfolioSelect;
